module.exports = __webpack_public_path__ + "img/mastercard.8004a779.svg";